import { enableProdMode, importProvidersFrom, isDevMode, provideZoneChangeDetection } from '@angular/core';

import { bootstrapApplication, BrowserModule, enableDebugTools } from '@angular/platform-browser';
import { PreloadAllModules, provideRouter, withHashLocation, withPreloading } from '@angular/router';

import { EnvService } from './services/env.service';
import { EnvServiceFactory } from './services/env-factory.service';
import { configureGoogleAnalytics } from './google-analytics';
import { CurrencyPipe, DatePipe, TitleCasePipe } from '@angular/common';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { EnvServiceProvider } from 'src/services/env-factory.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpConfigInterceptor } from 'src/services/http-config-interceptor';
import { ReAuthInterceptor } from 'src/services/reAuth.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { appRoutes } from './app/app.routes';
import { AppComponent } from './app/app.component';

const env: EnvService = EnvServiceFactory();

if (env.ENABLE_PROD_MODE) {
    enableProdMode();
}

configureGoogleAnalytics();

bootstrapApplication(AppComponent, {
    providers: [
        // Angular Router configuration with hash location for backward compatibility
        provideRouter(appRoutes, withHashLocation(), withPreloading(PreloadAllModules)),

        importProvidersFrom(
            BrowserModule,
            FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
            HttpClientModule,
            NgbPopoverModule,
            ReactiveFormsModule,
            NgxMaskDirective,
            NgxMaskPipe
        ),
        CurrencyPipe,
        DatePipe,
        TitleCasePipe,
        provideNgxMask(),
        JwtHelperService,
        { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
        EnvServiceProvider,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ReAuthInterceptor,
            multi: true
        },
        { provide: Window, useValue: window },
        provideZoneChangeDetection()
    ]
}).then((applicationRef) => {
    if (isDevMode()) {
        enableDebugTools(applicationRef as any);
    }
});
